function handleTrapEvent(lastFocusableElement, firstFocusableElement) {
	return function eventHandler(event) {
		var isTabPressed = event.key === 'Tab' || event.keyCode === 9;

		if (!isTabPressed) {
			return;
		}

		if (event.shiftKey) {
			if (document.activeElement === firstFocusableElement) {
				lastFocusableElement.focus();
				event.preventDefault();
			}
		} else if (document.activeElement === lastFocusableElement) {
			firstFocusableElement.focus();
			event.preventDefault();
		}
	};
}

function addTrapHandler(modal) {
	var focusableElements = Array.prototype.slice.call(
		modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
	).filter(function (el) {
		return !el.closest('[inert="inert"]');
	});
	var firstFocusableElement = focusableElements[0];
	var lastFocusableElement = focusableElements[focusableElements.length - 1];
	document.addEventListener('keydown', handleTrapEvent(lastFocusableElement, firstFocusableElement));
}

function triggerInert() {
	var quickLink = document.querySelector('.navigation-main__quick-links');
	var setInert = function () {
		if (window.innerWidth >= 979) {
			quickLink.setAttribute('inert', 'inert');
		} else {
			quickLink.removeAttribute('inert');
		}
	};
	setInert(); // Apply on load
	window.addEventListener('resize', setInert); // Apply on resize
}

document.addEventListener('DOMContentLoaded', function () {
	triggerInert();
	Array.prototype.forEach.call(document.querySelectorAll('.modal'), addTrapHandler);
});


//////////////////
// WEBPACK FOOTER
// ./src/js/focus_navigation.js
// module id = 1
// module chunks = 0